export const NORWEGIAN_ORG_NUMBER_REGEX = /^\d{9}$/;
export const DUNS_REGEX = /^\d{9}$/;

const MOD11_WEIGHTS = [3, 2, 7, 6, 5, 4, 3, 2];

export const normalizeOrgNumber = (orgNumber: string | null | undefined) => (orgNumber ?? "").replace(/\s/g, "");

// Norwegian org numbers are 9 digits where the last digit is a mod11 check digit.
export const isValidNorwegianOrgNumber = (orgNumber: string) => {
  if (!NORWEGIAN_ORG_NUMBER_REGEX.test(orgNumber)) return false;

  const sum = MOD11_WEIGHTS.reduce((acc, weight, i) => acc + weight * Number(orgNumber[i]), 0);
  const control = 11 - (sum % 11);
  const controlDigit = control === 11 ? 0 : control;

  return controlDigit !== 10 && controlDigit === Number(orgNumber[8]);
};

export const isValidDuns = (duns: string) => DUNS_REGEX.test(duns.trim());
